document.addEventListener( 'DOMContentLoaded', () => {
	const infoWrappers = document.querySelectorAll( '.info-wrapper' );

	if ( ! infoWrappers.length ) {
		return;
	}

	infoWrappers.forEach( wrapper => {
		const button = wrapper.querySelector( '.info-toggle' );
		const tooltip = wrapper.querySelector( '.info-tooltip' );

		if ( ! button ) {
			return;
		}
		const updatePosition = () => {
			wrapper.classList.remove( 'tooltip-right' );
			wrapper.classList.remove( 'tooltip-left' );
			wrapper.classList.remove( 'tooltip-top' );

			if ( window.innerWidth <= 1400 && window.innerWidth >= 950 ) {
				const card = wrapper.closest( '.achievement-card' );

				if ( card ) {
					const cardRect = card.getBoundingClientRect();
					const container = card.closest( '.achievement-container' );

					if ( ! container ) {
						return;
					}

					const containerRect = container.getBoundingClientRect();

					const relativeLeft = cardRect.left - containerRect.left;

					if ( relativeLeft > 140 ) {
						wrapper.classList.add( 'tooltip-right' );
					}
				}

				return;
			}

			if ( ! tooltip ) {
				return;
			}

			tooltip.style.visibility = 'hidden';
			tooltip.style.opacity = '1';
			tooltip.style.display = 'block';

			const rect = tooltip.getBoundingClientRect();

			if ( rect.right > window.innerWidth - 20 ) {
				wrapper.classList.add( 'tooltip-right' );
			}

			if ( rect.left < 20 ) {
				wrapper.classList.add( 'tooltip-left' );
			}

			const parentSection = wrapper.closest( '.achievement-block' );

			if ( parentSection ) {
				const parentRect = parentSection.getBoundingClientRect();
				const tooltipRect = tooltip.getBoundingClientRect();

				if ( tooltipRect.bottom > parentRect.bottom ) {
					wrapper.classList.add( 'tooltip-top' );
				}
			}

			tooltip.style.removeProperty( 'visibility' );
			tooltip.style.removeProperty( 'opacity' );
			tooltip.style.removeProperty( 'display' );
		};

		button.addEventListener( 'click', event => {
			event.preventDefault();
			event.stopPropagation();

			updatePosition();

			const isActive = wrapper.classList.contains( 'active' );

			document.querySelectorAll( '.info-wrapper.active' ).forEach( item => {
				item.classList.remove( 'active' );

				const activeButton = item.querySelector( '.info-toggle' );

				if ( activeButton ) {
					activeButton.setAttribute( 'aria-expanded', 'false' );
				}
			} );

			if ( ! isActive ) {
				wrapper.classList.add( 'active' );

				button.setAttribute( 'aria-expanded', 'true' );
			}
		} );

		button.addEventListener( 'mouseenter', updatePosition );

		window.addEventListener( 'resize', updatePosition );
	} );

	document.addEventListener( 'click', () => {
		document.querySelectorAll( '.info-wrapper.active' ).forEach( wrapper => {
			wrapper.classList.remove( 'active' );

			const button = wrapper.querySelector( '.info-toggle' );

			if ( button ) {
				button.setAttribute( 'aria-expanded', 'false' );
			}
		} );
	} );

	document.querySelectorAll( '.info-tooltip' ).forEach( tooltip => {
		tooltip.addEventListener( 'click', event => {
			event.stopPropagation();
		} );
	} );
} );
